
import React from 'react';
import { Menu, MenuItem } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export const ContractAdminOptions = ({ anchorEl, onClose }) => {
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  const handleRouterOptions = () => {
    onClose(); 
    navigate('/contracts/settings');
  };

  const handleRouterManagement = () => {
    onClose(); 
    navigate('/contracts/management');
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <MenuItem onClick={handleRouterOptions}>Opciones de configuración</MenuItem>
      <MenuItem onClick={handleRouterManagement}>Opciones de gestión</MenuItem>
    </Menu>
  );
};


